import { useSearchParams } from 'react-router-dom';
import { MessagingInbox } from '@gokrew/ui';

export const MessagesPage = () => {
  const [params, setParams] = useSearchParams();
  return (
    <MessagingInbox
      conversationId={params.get('conversation')}
      onConversationChange={(id) =>
        setParams(
          (previous) => {
            const next = new URLSearchParams(previous);
            if (id) next.set('conversation', id);
            else next.delete('conversation');
            return next;
          },
          { replace: true }
        )
      }
    />
  );
};
